import {enableAllPlugins} from 'immer'
enableAllPlugins()



// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/immer.ts